



















import { Component, Prop, Vue } from "vue-property-decorator";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCaretRight } from "@fortawesome/free-solid-svg-icons";

library.add(faCaretRight);

@Component({
  components: {
    FontAwesomeIcon,
  },
})
export default class StakeStatsVariation extends Vue {
  @Prop(String) private value!: number;
  @Prop(String) private direction!: string; //Allow: 'up' and 'down'
}
